import React from 'react';
import { Container, Heading, Box } from '@hover/blueprint';
import { PROJECT_VISIONS_LIST } from '../../../constants';
import ProjectVision from './ProjectVision';

const BringYourHomeProject: React.FC = () => (
  <Box w="100%" maxW="1200px" flexDir="column" alignItems="center">
    <Container
      maxW="4xl"
      centerContent
      mb={{ base: '72px', desktop: 1100 }}
      px={{ base: 500, desktop: 0 }}
    >
      <Heading
        textAlign="center"
        size={{ base: 500, tablet: 600, desktop: 700 }}
        fontWeight={{ base: 600, desktop: 700 }}
      >
        Dream it. See it. Do it.
      </Heading>
      <Heading
        textAlign="center"
        size={{ base: 200, desktop: 500 }}
        fontWeight={{ base: 400, desktop: 400 }}
      >
        Those photos don’t just turn out the most accurate measurements in the
        industry. They also create a 3D model of your actual home ready for you
        to style.
      </Heading>
    </Container>
    <Container maxW="100%">
      {PROJECT_VISIONS_LIST.map(project => (
        <ProjectVision
          projectVision={project}
          key={project.id}
          reverse={project.id === 1}
          marginBottom={{
            base:
              PROJECT_VISIONS_LIST.length !== project.id + 1 ? '72px' : 1000,
            desktop:
              PROJECT_VISIONS_LIST.length === project.id + 1 ? 1100 : '152px',
          }}
        />
      ))}
    </Container>
  </Box>
);

export default BringYourHomeProject;
